module.exports = {"id":"187607","name":"Artem Dzyuba","rating":"77","photo":"./data/images/photos/0/187607.png","club":{"name":"Arsenal Tula","logo":"./data/images/clubs/ArsenalTula.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArtemDzyuba0.json
// module id = 475
// module chunks = 0